import { createAction, props } from '@ngrx/store';
import { Resource } from '@ngxp/rest';
import { UserResource } from './user.model';

const PREFIX = '[User] ';

export const logInUserAction = createAction(PREFIX + 'Log In User');

export const logInUserSuccessAction = createAction(
	PREFIX + 'Log In User Success',
	props<{
		user: UserResource;
	}>()
);

export const logOutUserAction = createAction(PREFIX + 'Log Out User');

export const logOutUserSuccessAction = createAction(PREFIX + 'Log Out User Success');

export const unauthorizeUserAction = createAction(PREFIX + 'Unauthorize User');

export const loadUserAction = createAction(
	PREFIX + 'Load User',
	props<{
		resource: Resource;
		linkRel: string;
	}>()
);

export const loadUserSuccessAction = createAction(
	PREFIX + 'Load User Success',
	props<{
		user: UserResource;
	}>()
);
